import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeMoveTypeListItem extends SearchModelBase {
    moveType: string = '';
    inactive: boolean|null = null;
    inactiveAlt: boolean = false;
    id: number = 0;
    description: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Move Type', width: 150, dataIndex: 'moveType', noNullOrEmptySearch: true}),
        XCol.Create({ col: 1, text: 'Description', width: 100, dataIndex: 'description'}),
        XCol.Create({ col: 2, text: 'Inactive', width: 100, dataIndex: 'inactive', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection
    };
	
    public static OrderBy = { orderBy: CodeMoveTypeListItem.prototype.moveType, orderByAscending: true };

    public static formatData(data: CodeMoveTypeListItem[]) {
        return data.map((d: CodeMoveTypeListItem) => ({
          ...d,
        }));
    }

}
